// extracted by mini-css-extract-plugin
export default {"box":"DashboardSummary_box__6gTn8","boxActive":"DashboardSummary_boxActive__7g7wh"};